import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { APP_SETTINGS, ToastConfigService } from '@services';
import { Observable } from 'rxjs';
import { AnalyticsService } from '../../core/services/analytics/analytics.service';
import { AuthService } from '../../core/services/auth/auth.service';
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { AdminService } from '../admin/admin.service';
import { BodyPaintManualService } from '../body-and-paint-manual/body-paint-manual.service';
import { FaqAndTopLinksService } from '../faq-and-top-links/faq-and-top-links.service';
import { TechTrainingManualService } from '../tech-training-manual/tech-training-manual.service';
import { TechnicalDocumentationService } from '../technical-documentation/technical-documentation.service';
import { ToolsAndEquipmentManualsService } from '../tool-report/tools-and-equipment-manuals.service';
import { UserProfileService } from '../user-profile/user-profile.service';
import { CmsNavbarService } from './cms-navbar.service';
import { NgIf, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-cms-navbar',
    templateUrl: './cms-navbar.component.html',
    styleUrls: ['./cms-navbar.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        RouterLink,
        FormsModule,
        NgFor,
    ],
})
export class CmsNavbarComponent implements OnInit {

  @ViewChild('adminContent')
  adminContent: ElementRef;

  @ViewChild('addBulletinModal')
  addBulletinModal: ElementRef;

  @ViewChild('updateBulletinModal')
  updateBulletinModal: ElementRef;

  public showAdminNav: boolean = false;
  public expandNavbar = false;
  public width = 30;
  public inputContentType;
  public inputGroup: string;
  public inputMake: any;
  public mainGroupList = [];
  public isTakataRecall = false;
  public uploadedFileName = 'No File Selected';
  public uploadedFile;
  public bulletinNumber;
  public tkrCode = '';
  public manualCategory = '';
  public manualSubCategory = '';
  public userSelectedTechDoc = '';
  public chkTypeValue = '';
  public seriesList = '';

  public inputCategories;
  public inputSubCategories;
  public newManualCategory;
  public newCategoryDisabled = false;
  public newManualSubCategory;
  public newSubCategoryDisabled = false;

  public contentsList: any[];
  public bpmContentsList: any[];
  public sibContentsList: any[];
  public adminContentsList: any[];
  public partsContentsList: any[];

  public userSelectedCategory: any;
  public userSelectedSubCategory: any;

  public errorMessage = '';

  public faqOrTopLink: any;

  public reactivateOrDeactivate: any;

  public manualNumber = '';

  public uniqueDocNumber: Observable<any>;

  public textareaContent = '';
  public textareaContentHyperlink = '';

  public techDocAll: any[] = [];
  public techDocFilterded: any[] = [];
  public techDocCategories: any[] = [];
  public inputCategoriesGroup;
  public techDocSubCategories: any[] = [];
  public inputSubCategoriesGroup;
  public techDocTitles: any[] = [];
  public allTecData;

  public equipManuals: any[] = [];

  public documentNumbersList: string[] = [];

  public faqTopLinks: any[];
  public faqTopLinkDoc: any;

  private docId = '';
  public selDate = '';

  public action = '';
  public bulletinData = null;
  public makeNameForApi = '';

  public make: string;

  private userEmail: string;

  public partsBulletinId;

  private isAdmin: boolean = false;
  private isMotorradAdmin: boolean = false;
  private isRollsRoyceAdmin: boolean = false;


  public setDateFlag: boolean = false;
  public inputDate: any;
  public makeList = [];
  public userRoles = {};

  username;
  isDocActive = false;

  APP_SETTINGS: any;

  showTakata: boolean = false;
  showDefaultBn: boolean = true;
  mcbinfo = { options: 'mccurrent' };

  constructor(
    private readonly cmsNavbarService: CmsNavbarService,
    private readonly toastService: ToastConfigService,
    private readonly techDocService: TechnicalDocumentationService,
    private readonly spinnerService: SpinnerService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly techTrainingService: TechTrainingManualService,
    private readonly bodyPaintManualService: BodyPaintManualService,
    private readonly authService: AuthService,
    private readonly toolsEquipManualService: ToolsAndEquipmentManualsService,
    private readonly faqTopLinksService: FaqAndTopLinksService,
    private readonly userProfileService: UserProfileService,
    private readonly router: Router,
    private readonly utilityService: UtilityService,
    private readonly analyticsService: AnalyticsService,
    private readonly adminService: AdminService,) {
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;

    //Show Navigation Contents at this point
    this.showAdminNav = true;

    this.userRoles['isBMW'] = this.APP_SETTINGS.isBMW;
    this.userRoles['isMINI'] = this.APP_SETTINGS.isMini;
    this.userRoles['isMOTORRAD'] = this.APP_SETTINGS.isMOTORRAD;
    this.userRoles['isRollsRoyce'] = APP_SETTINGS.isRollsRoyce
    this.userRoles['isAdmin'] = this.APP_SETTINGS.isAdmin;
    this.userRoles['isMotorradAdmin'] = this.APP_SETTINGS.isMotorradAdmin;
    this.userRoles['isRollsRoyceAdmin'] = this.APP_SETTINGS.isRollsRoyceAdmin;
    this.userRoles['isExternal'] = this.APP_SETTINGS.isExternal;
    this.userRoles['isBPMAdmin'] = this.APP_SETTINGS.isBPMAdmin;
    this.userRoles['isMasterAdmin'] = this.APP_SETTINGS.isMasterAdmin;
    this.userRoles['isPartAdmin'] = this.APP_SETTINGS.isPartAdmin;
    this.userRoles['isSIBAdmin'] = this.APP_SETTINGS.isSIBAdmin;
    this.userRoles['sessionId'] = this.APP_SETTINGS.sessionId;
    this.userRoles['isDealer'] = this.APP_SETTINGS.isDealer;

    if (this.userRoles['isAdmin'] === 'true') {
      this.isAdmin = true;
    }
    if (this.userRoles['isMotorradAdmin'] === 'true') {
      this.isMotorradAdmin = true;
    }
    if (this.userRoles['isRollsRoyceAdmin'] === 'true') {
      this.isRollsRoyceAdmin = true;
    }
    this.uploadedFile = null;
    this.techDocCategories = [];
    this.techDocSubCategories = [];
    this.documentNumbersList = [];
    this.faqTopLinks = [];

    this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
      this.userEmail = userData['email'];
    });

    this.adminContentsList = [
      { id: 7, name: 'Video' },
      { id: 8, name: 'OBD' },
      { id: 9, name: 'Tool' },
      { id: 10, name: 'Equipment Manual' },
      { id: 11, name: 'FAQ & Top Links' },
      { id: 12, name: 'Technical Documentation' },
      { id: 13, name: 'Noise Catalog' },
      { id: 14, name: 'Scope Pattern Library' }
    ];

    // body and paint, training manuals contents list
    this.bpmContentsList = [
      { id: 5, name: 'Technical Training Manual' },
      { id: 6, name: 'Body & Paint Manual' }
    ];

    // parts contents list
    this.partsContentsList = [
      { id: 3, name: 'Parts Bulletin' }
    ];

    // sib and tri contents list
    this.sibContentsList = [
      { id: 1, name: 'Service Bulletin' },
    ];

    // modify the contents list based on admin roles
    if (this.userRoles['isAdmin'] === 'true') {
      this.contentsList = [...this.adminContentsList];

      if (this.APP_SETTINGS.isRollsRoyce === 'true') {
        const newArr = this.contentsList.filter(object => {
          return object.name !== 'Scope Pattern Library';
        });
        this.contentsList = newArr;
      } else if (this.APP_SETTINGS.isMOTORRAD === 'true') {
        this.contentsList = [...this.adminContentsList];
        const newArr = this.contentsList.filter(object => {
          return object.id === 'Video'
            || object.id === 'Equipment Manual'
            || object.id === 'Technical Documentation';
        });
        this.contentsList = newArr;
      }

      if (this.userRoles['isPartAdmin'] === 'true') {
        this.contentsList = [...this.partsContentsList, ...this.contentsList];
      }

      if (this.userRoles['isBPMAdmin'] === 'true') {
        this.contentsList = [...this.bpmContentsList, ...this.contentsList];
      }
      if (this.userRoles['isSIBAdmin'] === 'true') {
        this.contentsList = [...this.sibContentsList, ...this.contentsList];
      }
    } else if (this.userRoles['isMotorradAdmin'] === 'true') {
      this.contentsList = [...this.adminContentsList];
      const newArr = this.contentsList.filter(object => {
        return object.id === 'Video'
          || object.id === 'Equipment Manual'
          || object.id === 'Technical Documentation';
      });
      this.contentsList = newArr;
      if (this.userRoles['isPartAdmin'] === 'true') {
        this.contentsList = [...this.partsContentsList, ...this.contentsList];
      }

      if (this.userRoles['isBPMAdmin'] === 'true') {
        this.contentsList = [...this.bpmContentsList, ...this.contentsList];
      }
      if (this.userRoles['isSIBAdmin'] === 'true') {
        this.contentsList = [...this.sibContentsList, ...this.contentsList];
      }
    } else if (this.userRoles['isPartAdmin'] === 'true') {
      this.contentsList = [...this.partsContentsList];
      if (this.userRoles['isSIBAdmin'] === 'true') {
        this.contentsList = [...this.sibContentsList, ...this.contentsList];
      }
      if (this.userRoles['isBPMAdmin'] === 'true') {
        this.contentsList = [...this.contentsList, ...this.bpmContentsList];
      }
    } else if (this.userRoles['isSIBAdmin'] === 'true') {
      this.contentsList = [...this.sibContentsList];
      if (this.userRoles['isPartAdmin'] === 'true') {
        this.contentsList = [...this.contentsList, ...this.partsContentsList];
      }
      if (this.userRoles['isBPMAdmin'] === 'true') {
        this.contentsList = [...this.contentsList, ...this.bpmContentsList];
      }
    } else if (this.userRoles['isBPMAdmin'] === 'true') {
      this.contentsList = [...this.bpmContentsList];
      if (this.userRoles['isSIBAdmin'] === 'true') {
        this.contentsList = [...this.sibContentsList, ...this.contentsList];
      }
      if (this.userRoles['isPartAdmin'] === 'true') {
        this.contentsList = [...this.partsContentsList, ...this.contentsList];
      }
    } else if (this.userRoles['isRollsRoyceAdmin'] === 'true') {
      this.contentsList = [...this.adminContentsList];
      const newArr = this.contentsList.filter(object => {
        return object.name !== 'Scope Pattern Library';
      });
      if (this.userRoles['isSIBAdmin'] === 'true') {
        this.contentsList = [...this.sibContentsList, ...this.contentsList];
      }
      if (this.userRoles['isBPMAdmin'] === 'true') {
        this.contentsList = [...this.bpmContentsList, ...this.contentsList];
      }
      if (this.userRoles['isPartAdmin'] === 'true') {
        this.contentsList = [...this.partsContentsList, ...this.contentsList];
      }

    } else {
      console.error('ngOnInit UNKNOWN userRoles');
      this.contentsList = [];
    }

    if (APP_SETTINGS.isMOTORRAD === "true") {
      this.mainGroupList = APP_SETTINGS.motorradMainGroupList;
    }
    else {
      this.mainGroupList = this.APP_SETTINGS.mainGroupList;
    }

    this.cmsNavbarService.getAllMakeList().subscribe(data => {
      if (this.isMotorradAdmin === true) {
        this.makeList = data.filter(make => (make['makeName'] === 'MOTORRAD'));
      }
      if (this.isRollsRoyceAdmin === true) {
        this.makeList = data.filter(make => (make['makeName'] === 'ROLLSROYCE'));
      }
      else if (this.isAdmin === true) {
        this.makeList = data.filter(make => (make['makeName'] === 'BMW' || make['makeName'] === 'MINI' || make['makeName'] === 'MOTORRAD' || make['makeName'] === 'ROLLSROYCE'));
      }
    });
    this.newCategoryDisabled = false;
    this.inputCategoriesGroup = [];
    this.inputSubCategoriesGroup = [];
  }

  toggleNavbar() {
    this.expandNavbar = !this.expandNavbar;
    this.width = this.expandNavbar ? 120 : 30;
  }
  fileUpload(fileObj) {
    if (fileObj && fileObj.target.files.length > 0) {
      const file = fileObj.target.files[0];
      const isFileValid = this.utilityService.fileValidator(file.name);
      if (!isFileValid) {
        this.errorMessage = 'File type not supported';
        this.uploadedFile = null;
        this.uploadedFileName = '';
      } else {
        this.errorMessage = '';
        this.uploadedFile = file;
        this.uploadedFileName = file.name;
      }
    }
  }
  fetchUniqueDocNumber() {
    if (this.inputContentType.id === 12) {
      this.spinnerService.show('bmwSpinner');
      this.cmsNavbarService.getUniqueTechDocNumber().subscribe(data => {
        this.uniqueDocNumber = data['documentNumber'];
        this.spinnerService.hide('bmwSpinner');
      });
    } else if (this.inputContentType.id === 10) {
      this.spinnerService.show('bmwSpinner');
      this.cmsNavbarService.getUniqueEquipementManual().subscribe(data => {
        this.uniqueDocNumber = data['documentNumber'];
        this.spinnerService.hide('bmwSpinner');
      });
    }
  }
  fetchApiData(contentTypeId, makeName) {
    if (contentTypeId === 4 && this.inputGroup && this.inputGroup.length > 0 && this.inputGroup !== null) {
      this.spinnerService.show('bmwSpinner');
      this.adminService.getOPeratingFluidData(this.getOnlyMainGroupCode(this.inputGroup), makeName).subscribe(data => {
        if (data) {
          this.selDate = data['releaseDate'];
          this.docId = data['id'];
          this.inputMake = data['make']['makeName'];
          this.uniqueDocNumber = data['documentNumber'];
          this.textareaContent = data['documentTitle'];
          this.uploadedFileName = data['documentFileName'];
          this.isTakataRecall = data['takataRecallType'];
          this.tkrCode = this.isTakataRecall ? data['takataRecallCode'] : '';
          this.isDocActive = data['isActive'];
          this.spinnerService.hide('bmwSpinner');
        }
      });
    }
  }

  checkDateForTimestamp(tmpDate: any): string {
    if (tmpDate.length)
      return '';
  }

  formatBulletinNumber(event: any) {
    if (event.key == "ArrowLeft" || event.key == "ArrowRight" || event.keyCode == 8 || event.keyCode == 65 || event.keyCode == 67 || event.keyCode == 17) { return };
    let tempInput = this.bulletinNumber;
    let split = 2;
    let chunk = [];
    tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");

    for (let i = 0; i < this.bulletinNumber.length; i += split) {
      chunk.push(tempInput.substr(i, split));
    }
    tempInput = chunk.join(' ').trim();
    this.bulletinNumber = tempInput.slice(0, 8);
  }

  getAllTechDocs(makeName) {
    this.userSelectedTechDoc = '';
    this.spinnerService.show('bmwSpinner');
    this.techDocService.getTechDocsAllForAdmin(makeName).subscribe(data => {
      this.techDocAll = data as Array<any>;
      this.spinnerService.hide('bmwSpinner');
    });
  }
  getAllEquipmentManuals(makeName) {
    this.spinnerService.show('bmwSpinner');
    this.toolsEquipManualService.getAllEquipmentManualsForAdmin(makeName).subscribe(data => {
      this.spinnerService.hide('bmwSpinner');
      this.equipManuals = data;
    });
  }
  getAllBPMDocs(makeName) {
    this.spinnerService.show('bmwSpinner');
    this.bodyPaintManualService.getAllBodyPaintManualsForAdmin(makeName).subscribe(data => {
      this.spinnerService.hide('bmwSpinner');
      const techTrainingManuals: string[] = data;
      this.documentNumbersList = techTrainingManuals.map(manual => manual['documentNumber']);
    });
  }
  getAllTechTrainingManuals(makeName) {
    this.spinnerService.show('bmwSpinner');
    this.techTrainingService.getAllTechTrainingManualsForAdmin(makeName).subscribe(data => {
      this.spinnerService.hide('bmwSpinner');
      const techTrainingManuals: string[] = data;
      this.documentNumbersList = techTrainingManuals.map(manual => manual['documentNumber']);
    });
  }
  updateTechDocSubCategorySelection(category) {
    const categoroyObj = this.techDocAll.filter(doc => doc['title'] === category);
    this.techDocSubCategories = categoroyObj[0]['content'];
  }
  updateTechDocTitleSelection(subCategory) {
    const subCategoroyObj = this.techDocSubCategories.filter(subDoc => subDoc['title'] === subCategory);
    this.techDocTitles = subCategoroyObj[0]['content'];
  }
  retrieveTechDoc(techDoc, makeName) {
    this.spinnerService.show('bmwSpinner');
    techDoc = this.getTechDocNumber(techDoc);
    this.adminService.getTechDocInfo(techDoc, makeName).subscribe(techDocData => {
      this.spinnerService.hide('bmwSpinner');
      this.uniqueDocNumber = techDocData['documentNumber'];
      this.inputCategories = techDocData['documentCategory'];
      this.filterSubCategories();
      this.inputSubCategories = techDocData['documentSubCategory'];
      this.selDate = techDocData['releaseDate'];
      this.textareaContent = techDocData['documentTitle'];
      this.isTakataRecall = techDocData['takataRecallType'];
      this.inputMake = techDocData['make']['makeName'];
      this.tkrCode = this.isTakataRecall ? techDocData['takataRecallCode'] : '';
      this.docId = techDocData['id'];
      this.isDocActive = techDocData['isActive'];
      this.chkTypeValue = techDocData['attachmentType'];
      this.uploadedFileName = this.chkTypeValue === 'File' ? techDocData['documentFileName'] : '';
      this.textareaContentHyperlink = this.chkTypeValue === 'Link' ? techDocData['documentFileName'] : '';
      this.changeDetectorRef.detectChanges();
    }, error => {
      this.spinnerService.hide('bmwSpinner');
      this.errorMessage = error.error.errorMessage;
    });
  }

  getTechDocNumber(docTitle) {
    for (const element of this.techDocAll) {
      if (element.documentTitleKey.trim() == docTitle.trim()) {
        return element.documentNumber;
      }
    }
  }

  getPBSData(bulletinNumber, makeName) {
    this.spinnerService.show("bmwSpinner");

    this.adminService.getPBSDataWithBulletinNumber(this.bulletinNumber, makeName).subscribe(data => {
      if (data) {
        this.spinnerService.hide("bmwSpinner");
        this.bulletinData = data;
        this.docId = data['id'];
        this.errorMessage = '';
        this.isTakataRecall = data['takataRecallType'];
        this.tkrCode = data['takataRecallCode'] || '';
        this.isDocActive = data['isActive'];
        this.inputMake = data['make']['makeName'];
        this.textareaContent = data['description'];
        const mainGroupCode = data['mainGroupId'];
        this.inputGroup = this.fetchGroupNameFromGroupNumber(data['mainGroupId']);

        setTimeout(() => {
          this.inputDate = data['releaseDate'];
          this.selDate = data['releaseDate'];
        }, 50);
      }
    },
      error => {
        this.spinnerService.hide("bmwSpinner");
        this.errorMessage = error.error.message;
      });
  }
  fetchGroupNameFromGroupNumber(mainGroupCode) {
    const groupNameFromAPi: string[] = this.mainGroupList.filter(groupName => {
      const groupNum = groupName.split('[')[1].split(']')[0];
      return +groupNum === mainGroupCode;
    });
    return groupNameFromAPi[0];
  }
  getTechTrainingData(docNumber, makeName) {
    this.spinnerService.show("bmwSpinner");
    if (docNumber && docNumber !== null) {
      this.adminService.getTechTrainingManualInfo(docNumber, makeName).subscribe(data => {
        if (data) {
          this.selDate = data['releaseDate'];
          this.textareaContent = data['documentTitle'];
          this.isTakataRecall = data['takataRecallType'];
          this.uploadedFileName = data['documentFileName'];
          this.tkrCode = this.isTakataRecall ? data['takataRecallCode'] : '';
          this.inputMake = data['make']['makeName'];
          this.docId = data['id'];
          this.isDocActive = data['isActive'];
        }
        this.spinnerService.hide("bmwSpinner");
      });
    }
  }
  getBodyPaintManualData(docNumber, makeName) {
    this.spinnerService.show("bmwSpinner");
    if (docNumber && docNumber !== null) {
      this.adminService.getBodyAndPaintManualInfo(docNumber, makeName).subscribe(data => {
        if (data) {
          this.selDate = data['releaseDate'];
          this.textareaContent = data['documentTitle'];
          this.inputMake = data['make']['makeName'];
          this.isTakataRecall = data['takataRecallType'];
          this.uploadedFileName = data['documentFileName'];
          this.tkrCode = this.isTakataRecall ? data['takataRecallCode'] : '';
          this.docId = data['id'];
          this.isDocActive = data['isActive'];
        }
        this.spinnerService.hide("bmwSpinner");
      });
    }
  }
  getEquipManualDocumentNubers(category) {
    if (category && category !== null) {
      const categoryData: any[] = category['content'];
      this.documentNumbersList = categoryData.map(manual => manual['documentNumber']);
    }
  }
  getEquipManualData(docNumber, makeName) {
    this.spinnerService.show('bmwSpinner');
    if (docNumber && docNumber !== null) {
      this.adminService.getEquipmentManualInfo(docNumber, makeName).subscribe(data => {
        if (data) {
          this.selDate = data['releaseDate'];
          this.inputMake = data['make']['makeName'];
          this.textareaContent = data['documentTitle'];
          this.isTakataRecall = data['takataRecallType'];
          this.tkrCode = this.isTakataRecall ? data['takataRecallCode'] : '';
          this.docId = data['id'];
          this.isDocActive = data['isActive'];
          this.chkTypeValue = data['attachmentType'];
          this.textareaContentHyperlink = this.chkTypeValue === 'Link' ? data['documentFileName'] : '';
          this.uploadedFileName = this.chkTypeValue === 'File' ? data['documentFileName'] : '';
        }
        this.spinnerService.hide("bmwSpinner");
      });
    }
  }
  getfaqTopLinks(faqOrTopLink, makeName) {
    this.spinnerService.show("bmwSpinner");
    if (faqOrTopLink === 'faq') {
      this.faqTopLinksService.getFAQLinksForAdmin(makeName).subscribe(data => {
        this.faqTopLinks = data;
        this.spinnerService.hide("bmwSpinner");
      });
    } else if (faqOrTopLink === 'topLink') {
      this.faqTopLinksService.getTopLinksForAdmin(makeName).subscribe(data => {
        this.faqTopLinks = data;
        this.spinnerService.hide("bmwSpinner");
      });
    }
  }
  getFaqTopLinksData(faqTopLinkDoc, makeName) {
    if (faqTopLinkDoc && typeof faqTopLinkDoc === "object") {
      this.inputDate = faqTopLinkDoc['releaseDate'];
      this.selDate = faqTopLinkDoc['releaseDate'];
      this.textareaContent = faqTopLinkDoc['documentTitle'];
      this.uploadedFileName = faqTopLinkDoc['documentFileName'];
      this.inputMake = faqTopLinkDoc['make']['makeName'];
      this.docId = faqTopLinkDoc['id'];
      this.isDocActive = faqTopLinkDoc['isActive'];
      this.chkTypeValue = faqTopLinkDoc['attachmentType'];
      this.textareaContentHyperlink = this.chkTypeValue === 'Link' ? faqTopLinkDoc['documentFileName'] : '';
      this.uploadedFileName = this.chkTypeValue === 'File' ? faqTopLinkDoc['documentFileName'] : '';
    }
  }
  holdUserInputs() {
    this.inputDate ??= this.setDefaultDate();
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }
    let userInput = {};
    if (this.action === 'add') {
      userInput = {
        'contentType': this.inputContentType,
        'make': this.inputMake,
        'date': this.inputDate,
        'group': this.getOnlyMainGroupCode(this.inputGroup),
        'isTakataRecall': this.isTakataRecall,
        'tkrCode': this.tkrCode,
        'action': this.action
      };
    }
    if (this.action === 'edit') {
      if (this.userRoles['isBMW'] === 'true') {
        this.make = "BMW";
      } else if (this.userRoles['isMINI'] === 'true') {
        this.make = "MINI";
      } else if (this.userRoles['isMOTORRAD'] === 'true') {
        this.make = "MOTORRAD";
      } else if (this.userRoles['isRollsRoyce'] === 'true') {
        this.make = "ROLLSROYCE";
      } else {
        this.make = "BMW";
      }
      userInput = {
        'contentType': this.inputContentType,
        'action': this.action,
        'make': this.make
      };
    }
    this.cmsNavbarService.publishUserInputs(userInput);
    this.router.navigate(['add-bulletin']);
  }
  getOnlyMainGroupCode(mainGroup) {
    let mainGroupCode = '';
    if (mainGroup) {
      const matchString = mainGroup.match(/\[(.*?)\]/)[1];
      if (APP_SETTINGS.isMOTORRAD === 'true') {
        mainGroupCode = matchString;
      } else {
        mainGroupCode = +matchString < 10 ? '0' + matchString : matchString;
      }
      return mainGroupCode;
    }
    return mainGroupCode;
  }
  addPartsBulletin() {
    this.inputDate ??= this.setDefaultDate();
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }
    this.spinnerService.show("bmwSpinner");
    if (this.uploadedFile !== null && this.uploadedFileName !== 'No File Selected') {
      const formData = new FormData();
      formData.append('bulletinFile', this.uploadedFile, this.uploadedFileName);
      formData.append('subject', this.textareaContent);
      formData.append('makeName', this.inputMake.makeName);
      formData.append('mainGroupId', this.getOnlyMainGroupCode(this.inputGroup));
      formData.append('releaseDate', this.inputDate);
      formData.append('takataRecallCode', this.tkrCode);
      formData.append('takataRecallType', this.isTakataRecall.toString());
      this.adminService.createNewPartsBulletinWithFile(formData, this.bulletinNumber).subscribe(data => {
        if (data) {
          this.errorMessage = '';
          this.spinnerService.hide("bmwSpinner");
          this.addBulletinModal.nativeElement.click();
          this.toastService.popToast('Document added');
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    } else {
      const pbsObj = {
        'bulletinDisplayNumber': this.bulletinNumber,
        'description': this.textareaContent,
        'make': this.inputMake,
        'mainGroupId': this.getOnlyMainGroupCode(this.inputGroup),
        'releaseDate': this.inputDate,
        'takataRecallType': this.isTakataRecall,
        'takataRecallCode': this.tkrCode
      };
      this.adminService.createNewPartsBulletin(pbsObj).subscribe(data => {
        if (data) {
          this.errorMessage = '';
          this.spinnerService.hide("bmwSpinner");
          this.addBulletinModal.nativeElement.click();
          this.toastService.popToast('Document added');
          this.inputGroup = '';
          this.uploadedFile = null;
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    }
    this.analyticCallAddContent(this.inputContentType.name, this.inputMake.makeName, this.bulletinNumber);
  }

  analyticCallAddContent(bulletinType: string, makeName: string, bulletinNumber: string) {
    let userID = this.authService.getUserName();
    this.analyticsService.trackNewContentAdded(userID, bulletinType, makeName, bulletinNumber, 'added');
  }

  analyticCallUpdateContent(bulletinType: string, makeName: string, bulletinNumber: string) {
    let userID = this.authService.getUserName();
    this.analyticsService.trackEditContentUpdated(userID, bulletinType, makeName, bulletinNumber, 'updated');
  }

  clearContent() {
    this.inputContentType = null;
    this.uploadedFileName = '';
    this.uploadedFile = null;
    this.inputGroup = null;
    this.tkrCode = '';
    this.textareaContent = '';
    this.chkTypeValue = '';
    this.seriesList = '';
    this.userSelectedTechDoc = '';
    this.textareaContentHyperlink = '';
    this.isTakataRecall = false;
    this.manualNumber = '';
    this.manualCategory = '';
    this.manualSubCategory = '';
    this.newManualCategory = '';
    this.newManualSubCategory = '';
    this.inputCategories = '';
    this.inputSubCategories = '';
    this.inputDate = '';
    this.makeNameForApi = '';
    this.inputMake = '';
    this.faqOrTopLink = '';
    this.selDate = '';
    this.errorMessage = '';
    this.manualNumber = '';
    this.errorMessage = '';
  }
  addOperatingFluidsDoc() {
    this.inputDate ??= this.setDefaultDate();
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }
    this.errorMessage = '';
    this.spinnerService.show("bmwSpinner");
    const mainGroupNum = this.getOnlyMainGroupCode(this.inputGroup);
    if (this.uploadedFileName !== '' && this.uploadedFileName !== 'No File Selected') {
      const formData = new FormData();
      formData.append('documentTitle', this.textareaContent);
      formData.append('makeName', this.inputMake.makeName);
      formData.append('releaseDate', this.inputDate);
      formData.append('takataRecallCode', this.tkrCode);
      formData.append('takataRecallType', this.isTakataRecall.toString());
      formData.append('documentFile', this.uploadedFile, this.uploadedFileName);
      this.adminService.createNewOperatingFluidWithFile(formData, mainGroupNum).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.toastService.popToast('Document added');
          this.errorMessage = '';
          this.clearContent();
          this.addBulletinModal.nativeElement.click();
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    } else {
      const operFluidDoc = {
        'documentTitle': this.textareaContent,
        'make': this.inputMake,
        'releaseDate': this.inputDate,
        'takataRecallCode': this.tkrCode,
        'takataRecallType': this.isTakataRecall,
        'documentNumber': mainGroupNum,
        'documentFileName': this.uploadedFileName
      };
      this.adminService.createNewOperatingFluid(operFluidDoc).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.addBulletinModal.nativeElement.click();
          this.toastService.popToast('Document added');
          this.clearContent();
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    }
    this.analyticCallAddContent(this.inputContentType.name, this.inputMake.makeName, this.textareaContent);

  }
  formatDate(dateObj): string {
    if (dateObj.length > 10) {
      dateObj = dateObj.substring(0, 10);
    }
    const date = dateObj.split('-');
    // MM-DD-YYYY
    if (date[2].length > 2) {
      return date[2] + '-' + date[0] + '-' + date[1];
    }
    // YYYY-MM-DD
    return date[1] + '-' + date[2] + '-' + date[0];
  }
  addTechTrainingManual() {
    this.spinnerService.show("bmwSpinner");
    this.inputDate ??= this.setDefaultDate();
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }
    if (this.uploadedFileName !== '' && this.uploadedFileName !== 'No File Selected') {
      const formData = new FormData();
      formData.append('documentTitle', this.textareaContent);
      formData.append('makeName', this.inputMake.makeName);
      formData.append('releaseDate', this.inputDate);
      formData.append('takataRecallCode', this.tkrCode);
      formData.append('takataRecallType', this.isTakataRecall.toString());
      formData.append('documentFile', this.uploadedFile, this.uploadedFileName);
      this.adminService.createNewTechTrainingManualWithFile(formData, this.manualNumber).subscribe(data => {
        this.spinnerService.hide("bmwSpinner");
        this.toastService.popToast('Document added');
        this.clearContent();
        this.errorMessage = '';
        this.addBulletinModal.nativeElement.click();
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    } else {
      const manualData = {
        'documentTitle': this.textareaContent,
        'make': this.inputMake,
        'releaseDate': this.inputDate,
        'takataRecallCode': this.tkrCode,
        'takataRecallType': this.isTakataRecall,
        'documentFileName': this.uploadedFileName,
        'documentNumber': this.manualNumber
      };
      this.adminService.createNewTechTrainingManual(manualData).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.addBulletinModal.nativeElement.click();
          this.toastService.popToast('Document added');
          this.clearContent();
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    }
    this.analyticCallAddContent(this.inputContentType.name, this.inputMake.makeName, this.manualNumber);
  }
  addBodyPaintManual() {

    this.inputDate ??= this.setDefaultDate();
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }
    this.spinnerService.show("bmwSpinner");
    if (this.uploadedFileName !== '' && this.uploadedFileName !== 'No File Selected') {
      const formData = new FormData();
      formData.append('documentTitle', this.textareaContent);
      formData.append('makeName', this.inputMake.makeName);
      formData.append('releaseDate', this.inputDate);
      formData.append('takataRecallCode', this.tkrCode);
      formData.append('takataRecallType', this.isTakataRecall.toString());
      formData.append('documentFile', this.uploadedFile, this.uploadedFileName);
      this.adminService.createNewBodyAndPaintManualWithFile(formData, this.manualNumber).subscribe(data => {
        this.spinnerService.hide("bmwSpinner");
        this.toastService.popToast('Document added');
        this.clearContent();
        this.errorMessage = '';
        this.addBulletinModal.nativeElement.click();
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    } else {
      const manualData = {
        'documentTitle': this.textareaContent,
        'make': this.inputMake,
        'releaseDate': this.inputDate,
        'takataRecallCode': this.tkrCode,
        'documentFileName': this.uploadedFileName,
        'takataRecallType': this.isTakataRecall,
        'documentNumber': this.manualNumber
      };
      this.adminService.createNewBodyAndPaintManual(manualData).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.addBulletinModal.nativeElement.click();
          this.toastService.popToast('Document added');
          this.clearContent();
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    }
    this.analyticCallAddContent(this.inputContentType.name, this.inputMake.makeName, this.manualNumber);
  }
  addEquipManual() {
    this.inputDate ??= this.setDefaultDate();
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }

    if (this.textareaContent.length <= 0) {
      this.errorMessage = "*Manual Name is required"
      return;
    }

    if (this.chkTypeValue === '') {
      this.errorMessage = "*File or Hyperlink is required"
      return;
    }

    this.spinnerService.show("bmwSpinner");
    if (this.uploadedFileName !== '' && this.uploadedFileName !== 'No File Selected' && this.chkTypeValue === 'File') {
      const formData = new FormData();
      formData.append('documentCategory', this.manualCategory);
      formData.append('documentTitle', this.textareaContent);
      formData.append('makeName', this.inputMake.makeName);
      formData.append('releaseDate', this.inputDate);
      formData.append('takataRecallCode', this.tkrCode);
      formData.append('takataRecallType', this.isTakataRecall.toString());
      formData.append('documentFile', this.uploadedFile, this.uploadedFileName);
      formData.append('attachmentType', this.chkTypeValue);
      this.adminService.createNewEquipementManualWithFile(formData, this.uniqueDocNumber).subscribe(data => {
        this.spinnerService.hide("bmwSpinner");
        this.toastService.popToast('Document added');
        this.clearContent();
        this.errorMessage = '';
        this.addBulletinModal.nativeElement.click();
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    } else {
      if (this.textareaContentHyperlink.length <= 0 && this.chkTypeValue === 'Link') {
        this.errorMessage = "*Hyperlink is required"
        this.spinnerService.hide("bmwSpinner");
        return;
      }
      const manualData = {
        'documentCategory': this.manualCategory,
        'documentTitle': this.textareaContent,
        'make': this.inputMake,
        'releaseDate': this.inputDate,
        'takataRecallCode': this.tkrCode,
        'takataRecallType': this.isTakataRecall,
        'documentFileName': this.textareaContentHyperlink,
        'documentNumber': this.uniqueDocNumber,
        'attachmentType': this.chkTypeValue,
      };
      this.adminService.createNewEquipementManual(manualData).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.addBulletinModal.nativeElement.click();
          this.toastService.popToast('Document added');
          this.clearContent();
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    }
    this.analyticCallAddContent(this.inputContentType.name, this.inputMake.makeName, this.textareaContent);
  }
  addTechDoc() {
    this.inputDate ??= this.setDefaultDate();
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }

    this.manualCategory = this.newManualCategory;
    if (this.inputCategories.length > 0 && this.inputCategories !== "Select Category") {
      this.manualCategory = this.inputCategories;
    }

    this.manualSubCategory = this.newManualSubCategory;
    if (this.inputSubCategories.length > 0 && this.inputCategories !== "Select SubCategory") {
      this.manualSubCategory = this.inputSubCategories;
    }

    if (this.manualCategory.length <= 0 || this.manualSubCategory.length <= 0) {
      this.errorMessage = "*Category and Subcatgeory are required"
      return;
    }

    if (this.manualCategory === "Select Category" && this.newManualCategory.length <= 0) {
      this.errorMessage = "*Category is required"
      return;
    }

    if (this.manualSubCategory === "Select SubCategory" && this.newManualSubCategory.length <= 0) {
      this.errorMessage = "*Subcategory is required"
      return;
    }

    if (this.textareaContent.length <= 0) {
      this.errorMessage = "*Document Name is required"
      return;
    }

    if (this.chkTypeValue === '') {
      this.errorMessage = "*File or Hyperlink is required"
      return;
    }

    if (this.uploadedFile === null && this.chkTypeValue === 'File') {
      this.errorMessage = "*File is required"
      return;
    }

    this.spinnerService.show("bmwSpinner");
    if (this.uploadedFile !== null && this.chkTypeValue === 'File') {
      const formData = new FormData();
      formData.append('documentCategory', this.manualCategory);
      formData.append('documentSubCategory', this.manualSubCategory);
      formData.append('documentTitle', this.textareaContent);
      formData.append('makeName', this.inputMake.makeName);
      formData.append('releaseDate', this.inputDate);
      formData.append('takataRecallCode', this.tkrCode);
      formData.append('takataRecallType', this.isTakataRecall.toString());
      formData.append('documentFile', this.uploadedFile, this.uploadedFileName);
      formData.append('attachmentType', this.chkTypeValue);
      this.adminService.createNewTechnicalDocumentWithFile(formData, this.uniqueDocNumber).subscribe(data => {
        this.spinnerService.hide("bmwSpinner");
        this.toastService.popToast('Document added');
        this.uploadedFile = null;
        this.errorMessage = '';
        this.clearContent();
        this.addBulletinModal.nativeElement.click();
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    } else {
      if (this.textareaContentHyperlink.length <= 0 && this.chkTypeValue === 'Link') {
        this.errorMessage = "*Hyperlink is required"
        this.spinnerService.hide("bmwSpinner");
        return;
      }
      const manualData = {
        'documentNumber': this.uniqueDocNumber,
        'documentCategory': this.manualCategory,
        'documentSubCategory': this.manualSubCategory,
        'documentTitle': this.textareaContent,
        'make': this.inputMake,
        'releaseDate': this.inputDate,
        'takataRecallCode': this.tkrCode,
        'takataRecallType': this.isTakataRecall,
        'documentFileName': this.textareaContentHyperlink,
        'attachmentType': this.chkTypeValue,
      };
      this.adminService.createNewTechnicalDocument(manualData).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.addBulletinModal.nativeElement.click();
          this.toastService.popToast('Document added');
          this.uploadedFile = null;
          this.clearContent();
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });

    }

    this.inputCategoriesGroup = [];
    this.inputSubCategoriesGroup = [];
    this.newCategoryDisabled = true;
    this.newSubCategoryDisabled = true;
    this.analyticCallAddContent("Technical Documentation", this.inputMake.makeName, this.textareaContent);
  }
  addFAQOrTopLink() {
    this.inputDate ??= this.setDefaultDate();
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }

    if (this.textareaContent.length <= 0) {
      this.errorMessage = "*Document Name is required"
      return;
    }

    if (this.chkTypeValue === '') {
      this.errorMessage = "*File or Hyperlink is required"
      return;
    }

    this.spinnerService.show("bmwSpinner");
    const formData = new FormData();
    if (this.chkTypeValue === 'File') {
      if (this.uploadedFile !== null) {
        formData.append('documentFile', this.uploadedFile, this.uploadedFileName);
      }
      formData.append('documentTitle', this.textareaContent);
    }
    else {
      if (this.textareaContentHyperlink.length <= 0 && this.chkTypeValue === 'Link') {
        this.errorMessage = "*Hyperlink is required"
        this.spinnerService.hide("bmwSpinner");
        return;
      }
      formData.append('documentFileName', this.textareaContentHyperlink);
      formData.append('documentTitle', this.textareaContent);
    }
    formData.append('makeName', this.inputMake.makeName);
    formData.append('releaseDate', this.inputDate);
    formData.append('attachmentType', this.chkTypeValue);
    if (this.faqOrTopLink === 'faq') {
      this.adminService.createNewFAQ(formData).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.toastService.popToast('FAQ Document added');
          this.errorMessage = '';
          this.clearContent();
          this.addBulletinModal.nativeElement.click();
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    } else if (this.faqOrTopLink === 'topLink') {
      this.adminService.createNewTopLink(formData).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.toastService.popToast('Top Link Document added');
          this.errorMessage = '';
          this.clearContent();
          this.addBulletinModal.nativeElement.click();
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    }
    this.analyticCallAddContent("FAQ & Top Links", this.inputMake.makeName, this.textareaContent);
  }
  updatePartsBulletin() {
    this.inputDate ??= this.setDefaultDate();
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }
    this.spinnerService.show("bmwSpinner");
    const selectedMake = this.makeList.find(make => make['makeName'] === this.inputMake);
    if (this.uploadedFile !== null && this.uploadedFileName !== 'No File Selected') {
      const formData = new FormData();
      formData.append('bulletinFile', this.uploadedFile, this.uploadedFileName);
      formData.append('subject', this.textareaContent);
      formData.append('bulletinNumber', this.bulletinNumber);
      formData.append('makeName', selectedMake.makeName);
      formData.append('mainGroupId', this.getOnlyMainGroupCode(this.inputGroup));
      formData.append('releaseDate', this.inputDate);
      formData.append('takataRecallCode', this.tkrCode);
      formData.append('takataRecallType', this.isTakataRecall.toString());
      this.adminService.updatePBSWithFile(formData, this.docId).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.clearContent();
          this.updateBulletinModal.nativeElement.click();
          this.toastService.popToast('Document updated');
          this.reactivateOrDeactivateDocument(this.reactivateOrDeactivate, 'pbs', this.docId, selectedMake.makeName);
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    } else {
      const pbsObj = {
        'id': this.docId,
        'bulletinDisplayNumber': this.bulletinNumber,
        'bulletinDisplayId': this.bulletinNumber,
        'description': this.textareaContent,
        'make': selectedMake,
        'mainGroupId': this.getOnlyMainGroupCode(this.inputGroup),
        'releaseDate': this.inputDate,
        'takataRecallType': this.isTakataRecall,
        'takataRecallCode': this.tkrCode
      };
      this.adminService.updatePBS(pbsObj).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.updateBulletinModal.nativeElement.click();
          this.toastService.popToast('Document updated');
          this.reactivateOrDeactivateDocument(this.reactivateOrDeactivate, 'pbs', this.docId, selectedMake.makeName);
          this.clearContent();
          this.uploadedFile = null;
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    }
    this.analyticCallUpdateContent(this.inputContentType.name, this.makeNameForApi, this.bulletinNumber);
  }

  updateTechDoc() {
    this.inputDate ??= this.setDefaultDate();
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }

    this.manualCategory = this.newManualCategory;
    if (this.inputCategories.length > 0 && this.inputCategories !== "Select Category") {
      this.manualCategory = this.inputCategories;
    }

    this.manualSubCategory = this.newManualSubCategory;
    if (this.inputSubCategories.length > 0 && this.inputSubCategories !== "Select SubCategory") {
      this.manualSubCategory = this.inputSubCategories;
    }

    if (this.manualCategory.length <= 0 || this.manualSubCategory.length <= 0) {
      this.errorMessage = "*Category and Subcatgeory are required"
      return;
    }

    if (this.manualCategory === "Select Category" && this.newManualCategory.length <= 0) {
      this.errorMessage = "*Category is required"
      return;
    }

    if (this.manualSubCategory === "Select SubCategory" && this.newManualSubCategory.length <= 0) {
      this.errorMessage = "*Subcatgeory is required"
      return;
    }

    if (this.textareaContent.length <= 0) {
      this.errorMessage = "*Document Name is required"
      return;
    }

    if (this.chkTypeValue === '') {
      this.errorMessage = "*File or Hyperlink is required"
      return;
    }

    this.spinnerService.show("bmwSpinner");
    const selectedMake = this.makeList.find(make => make['makeName'] === this.inputMake);
    if (this.uploadedFile !== null && this.chkTypeValue === 'File') {
      const formData = new FormData();
      formData.append('id', this.docId);
      formData.append('documentNumber', this.uniqueDocNumber.toString());
      formData.append('documentCategory', this.manualCategory);
      formData.append('documentSubCategory', this.manualSubCategory);
      formData.append('documentTitle', this.textareaContent);
      formData.append('makeName', selectedMake.makeName);
      formData.append('releaseDate', this.inputDate);
      formData.append('takataRecallCode', this.tkrCode);
      formData.append('takataRecallType', this.isTakataRecall.toString());
      formData.append('documentFile', this.uploadedFile, this.uploadedFileName);
      formData.append('attachmentType', this.chkTypeValue);
      this.adminService.updateTechnicalDocumentWithFile(formData, this.docId).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.updateBulletinModal.nativeElement.click();
          this.clearContent();
          this.reactivateOrDeactivateDocument(this.reactivateOrDeactivate, 'td', this.docId, selectedMake.makeName);
          this.toastService.popToast('Document updated');
          this.uploadedFile = null;
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    } else {
      if (this.textareaContentHyperlink.length <= 0 && this.chkTypeValue === 'Link') {
        this.errorMessage = "*Hyperlink is required"
        this.spinnerService.hide("bmwSpinner");
        return;
      }
      const manualData = {
        'id': this.docId,
        'documentNumber': this.uniqueDocNumber,
        'documentCategory': this.manualCategory,
        'documentSubCategory': this.manualSubCategory,
        'documentTitle': this.textareaContent,
        'make': selectedMake,
        'releaseDate': this.inputDate,
        'takataRecallCode': this.tkrCode,
        'takataRecallType': this.isTakataRecall,
        'isActive': this.isDocActive,
        'documentFileName': this.textareaContentHyperlink,
        'attachmentType': this.chkTypeValue,
      };
      this.adminService.updateTechnicalDocument(manualData).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.clearContent();
          this.updateBulletinModal.nativeElement.click();
          this.reactivateOrDeactivateDocument(this.reactivateOrDeactivate, 'td', this.uniqueDocNumber, selectedMake.makeName);
          this.toastService.popToast('Document updated');
          this.uploadedFile = null;
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    }

    this.inputCategoriesGroup = [];
    this.inputSubCategoriesGroup = [];
    this.newCategoryDisabled = true;
    this.newSubCategoryDisabled = true;
  }

  filterCategories(make: string) {

    this.inputCategories = '';
    this.manualCategory = '';

    this.inputSubCategories = '';
    this.manualSubCategory = '';

    this.filterSubCategories();
    this.spinnerService.show('bmwSpinner');

    this.techDocService.getTechDocsAllForAdmin(make).subscribe(data => {

      this.techDocFilterded = data as Array<any>;
      let categoriesArray = [];

      if (this.techDocFilterded) {
        this.techDocFilterded.forEach(element => {
          if (element.hasOwnProperty('documentCategory')) {
            let tempCategory = element['documentCategory'];
            if (tempCategory.length > 0 && !categoriesArray.includes(tempCategory)) {
              categoriesArray.push(tempCategory);
            }
          }
        });
      }
      this.inputCategoriesGroup = categoriesArray.sort();

      if (this.inputCategoriesGroup.length == 0)
        this.newCategoryDisabled = false;

      this.spinnerService.hide('bmwSpinner');
    });


  }

  filterCategoriesActive(make: string) {

    this.inputCategories = '';
    this.manualCategory = '';

    this.inputSubCategories = '';
    this.manualSubCategory = '';

    this.filterSubCategories();
    this.spinnerService.show('bmwSpinner');

    this.techDocService.getTechDocsAllForAdminActive(make).subscribe(data => {

      this.techDocFilterded = data as Array<any>;
      let categoriesArray = [];

      if (this.techDocFilterded) {
        this.techDocFilterded.forEach(element => {
          if (element.hasOwnProperty('documentCategory')) {
            let tempCategory = element['documentCategory'];
            if (tempCategory.length > 0 && !categoriesArray.includes(tempCategory)) {
              categoriesArray.push(tempCategory);
            }
          }
        });
      }
      this.inputCategoriesGroup = categoriesArray.sort();
      this.spinnerService.hide('bmwSpinner');
    });


  }

  filterSubCategories() {
    this.newCategoryDisabled = !((this.inputCategories === 'Select Category' || this.inputCategories === ''));
    if (this.newSubCategoryDisabled) {
      this.newSubCategoryDisabled = true;
    }

    this.inputSubCategories = '';
    this.manualSubCategory = '';

    let subCategoriesArray = [];

    const subCategoriesFiltered = this.techDocFilterded.filter(obj => obj['documentCategory'] === this.inputCategories);

    if (subCategoriesFiltered) {
      subCategoriesFiltered.forEach(element => {
        if (element.hasOwnProperty('documentSubCategory')) {
          let tempSubCategory = element['documentSubCategory'];

          if (tempSubCategory.length > 0 && !subCategoriesArray.includes(tempSubCategory)) {
            subCategoriesArray.push(tempSubCategory);
          }
        }
      });
    }
    this.inputSubCategoriesGroup = subCategoriesArray.sort();

    if (this.inputSubCategoriesGroup.length == 0)
      this.newSubCategoryDisabled = false;

  }

  selectSubCategories() {
    this.newSubCategoryDisabled = this.inputSubCategories !== 'Select SubCategory';
  }

  updateOperatingFluidsDoc() {
    this.analyticCallUpdateContent(this.inputContentType.name, this.makeNameForApi, this.textareaContent);

    this.inputDate ??= this.setDefaultDate();
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }
    this.spinnerService.show("bmwSpinner");
    const selectedMake = this.makeList.find(make => make['makeName'] === this.inputMake);
    const groupCode = this.getOnlyMainGroupCode(this.inputGroup);
    if (this.uploadedFile !== null) {
      const formData = new FormData();
      formData.append('id', this.docId);
      formData.append('documentNumber', groupCode);
      formData.append('documentTitle', this.textareaContent);
      formData.append('makeName', selectedMake.makeName);
      formData.append('releaseDate', this.inputDate);
      formData.append('takataRecallCode', this.tkrCode);
      formData.append('takataRecallType', this.isTakataRecall.toString());
      formData.append('documentFile', this.uploadedFile, this.uploadedFileName);
      this.adminService.updateOperatingFluidWithFile(formData, this.docId).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.updateBulletinModal.nativeElement.click();
          this.clearContent();
          this.reactivateOrDeactivateDocument(this.reactivateOrDeactivate, 'of', groupCode, selectedMake.makeName);
          this.toastService.popToast('Document updated');
          this.uploadedFile = null;
          this.inputGroup = null;
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    } else {
      const manualData = {
        'id': this.docId,
        'documentNumber': groupCode,
        'documentTitle': this.textareaContent,
        'make': selectedMake,
        'releaseDate': this.inputDate,
        'takataRecallCode': this.tkrCode,
        'takataRecallType': this.isTakataRecall,
        'documentFileName': this.uploadedFileName
      };
      this.adminService.updateOperatingFluid(manualData).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.updateBulletinModal.nativeElement.click();
          this.reactivateOrDeactivateDocument(this.reactivateOrDeactivate, 'of', groupCode, selectedMake.makeName);
          this.toastService.popToast('Document updated');
          this.uploadedFile = null;
          this.clearContent();
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    }
  }
  updateTechTrainingManual() {
    this.analyticCallUpdateContent(this.inputContentType.name, this.makeNameForApi, this.manualNumber);
    this.inputDate ??= this.setDefaultDate();
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }
    this.spinnerService.show("bmwSpinner");
    const selectedMake = this.makeList.find(make => make['makeName'] === this.inputMake);
    if (this.uploadedFile !== null) {
      const formData = new FormData();
      formData.append('id', this.docId);
      formData.append('documentNumber', this.manualNumber);
      formData.append('documentTitle', this.textareaContent);
      formData.append('makeName', selectedMake.makeName);
      formData.append('releaseDate', this.inputDate);
      formData.append('takataRecallCode', this.tkrCode);
      formData.append('takataRecallType', this.isTakataRecall.toString());
      formData.append('documentFile', this.uploadedFile, this.uploadedFileName);
      this.adminService.updateTechTrainingManualWithFile(formData, this.docId).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.updateBulletinModal.nativeElement.click();
          this.reactivateOrDeactivateDocument(this.reactivateOrDeactivate, 'tm', this.manualNumber, selectedMake.makeName);
          this.toastService.popToast('Document updated');
          this.clearContent();
          this.manualNumber = '';
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    } else {
      const manualData = {
        'id': this.docId,
        'documentNumber': this.manualNumber,
        'documentTitle': this.textareaContent,
        'make': selectedMake,
        'releaseDate': this.inputDate,
        'takataRecallCode': this.tkrCode,
        'takataRecallType': this.isTakataRecall,
        'documentFileName': this.uploadedFileName
      };
      this.adminService.updateTechTrainingManual(manualData).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.updateBulletinModal.nativeElement.click();
          this.reactivateOrDeactivateDocument(this.reactivateOrDeactivate, 'tm', this.manualNumber, selectedMake.makeName);
          this.toastService.popToast('Document updated');
          this.clearContent();
          this.manualNumber = '';
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    }
  }
  updateBodyPaintManual() {
    this.analyticCallUpdateContent(this.inputContentType.name, this.makeNameForApi, this.manualNumber);
    this.inputDate ??= this.setDefaultDate();
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }
    this.spinnerService.show("bmwSpinner");
    const selectedMake = this.makeList.find(make => make['makeName'] === this.inputMake);
    if (this.uploadedFile !== null) {
      const formData = new FormData();
      formData.append('id', this.docId);
      formData.append('documentNumber', this.manualNumber);
      formData.append('documentTitle', this.textareaContent);
      formData.append('makeName', selectedMake.makeName);
      formData.append('releaseDate', this.inputDate);
      formData.append('takataRecallCode', this.tkrCode);
      formData.append('takataRecallType', this.isTakataRecall.toString());
      formData.append('documentFile', this.uploadedFile, this.uploadedFileName);
      this.adminService.updateBodyAndPaintManualWithFile(formData, this.docId).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.updateBulletinModal.nativeElement.click();
          this.reactivateOrDeactivateDocument(this.reactivateOrDeactivate, 'bpm', this.manualNumber, selectedMake.makeName);
          this.toastService.popToast('Document updated');
          this.clearContent();
          this.manualNumber = '';
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    } else {
      const manualData = {
        'id': this.docId,
        'documentNumber': this.manualNumber,
        'documentTitle': this.textareaContent,
        'make': selectedMake,
        'releaseDate': this.inputDate,
        'takataRecallCode': this.tkrCode,
        'takataRecallType': this.isTakataRecall,
        'documentFileName': this.uploadedFileName
      };
      this.adminService.updateBodyAndPaintManual(manualData).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.updateBulletinModal.nativeElement.click();
          this.reactivateOrDeactivateDocument(this.reactivateOrDeactivate, 'bpm', this.manualNumber, selectedMake.makeName);
          this.toastService.popToast('Document updated');
          this.clearContent();
          this.manualNumber = '';
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    }
  }
  updateEquipManual() {
    this.analyticCallUpdateContent(this.inputContentType.name, this.makeNameForApi, this.textareaContent);
    this.inputDate ??= this.setDefaultDate();
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }

    if (this.textareaContent.length <= 0) {
      this.errorMessage = "*Manual Name is required"
      return;
    }

    if (this.chkTypeValue === '') {
      this.errorMessage = "*File or Hyperlink is required"
      return;
    }

    this.spinnerService.show("bmwSpinner");
    this.makeNameForApi = null;
    const selectedMake = this.makeList.find(make => make['makeName'] === this.inputMake);

    if (this.uploadedFile !== null && this.chkTypeValue === 'File') {
      const formData = new FormData();
      formData.append('id', this.docId);
      formData.append('documentNumber', this.manualNumber);
      formData.append('documentTitle', this.textareaContent);
      formData.append('makeName', selectedMake.makeName);
      formData.append('releaseDate', this.inputDate);
      formData.append('takataRecallCode', this.tkrCode);
      formData.append('takataRecallType', this.isTakataRecall.toString());
      formData.append('documentFile', this.uploadedFile, this.uploadedFileName);
      formData.append('attachmentType', this.chkTypeValue);
      this.adminService.updateEquipmentManualWithFile(formData, this.docId).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.updateBulletinModal.nativeElement.click();
          this.reactivateOrDeactivateDocument(this.reactivateOrDeactivate, 'eq', this.manualNumber, selectedMake.makeName);
          this.toastService.popToast('Document updated');
          this.clearContent();
          this.manualNumber = '';
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    } else {
      if (this.textareaContentHyperlink.length <= 0 && this.chkTypeValue === 'Link') {
        this.errorMessage = "*Hyperlink is required"
        this.spinnerService.hide("bmwSpinner");
        return;
      }
      const manualData = {
        'id': this.docId,
        'documentNumber': this.manualNumber,
        'documentTitle': this.textareaContent,
        'make': selectedMake,
        'releaseDate': this.inputDate,
        'takataRecallCode': this.tkrCode,
        'takataRecallType': this.isTakataRecall,
        'documentFileName': this.textareaContentHyperlink,
        'attachmentType': this.chkTypeValue,
      };
      this.adminService.updateEquipmentManual(manualData).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.updateBulletinModal.nativeElement.click();
          this.reactivateOrDeactivateDocument(this.reactivateOrDeactivate, 'eq', this.manualNumber, selectedMake.makeName);
          this.toastService.popToast('Document updated');
          this.clearContent();
          this.manualNumber = '';
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    }
  }
  reactivateOrDeactivateFaqTopLink(reactivateOrDeactivate: string) {
    this.spinnerService.show("bmwSpinner");
    const selectedMake = this.makeList.find(make => make['makeName'] === this.inputMake);
    if (this.faqOrTopLink === 'faq') {
      this.reactivateOrDeactivateDocument(reactivateOrDeactivate, 'faq', this.docId, selectedMake.makeName);
    }
    if (this.faqOrTopLink === 'topLink') {
      this.reactivateOrDeactivateDocument(reactivateOrDeactivate, 'topLink', this.docId, selectedMake.makeName);
    }
  }
  updateFAQOrTopLink() {
    this.analyticCallUpdateContent("FAQ & Top Links", this.makeNameForApi, this.textareaContent);
    this.inputDate ??= this.setDefaultDate();
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }

    if (this.textareaContent.length <= 0) {
      this.errorMessage = "*Document Name is required"
      return;
    }

    if (this.chkTypeValue === '') {
      this.errorMessage = "*File or Hyperlink is required"
      return;
    }

    this.spinnerService.show("bmwSpinner");
    const selectedMake = this.makeList.find(make => make['makeName'] === this.inputMake);
    const formData = new FormData();
    if (this.chkTypeValue === 'File') {
      if (this.uploadedFile !== null) {
        formData.append('documentFile', this.uploadedFile, this.uploadedFileName);
      }
      formData.append('documentTitle', this.textareaContent);
    }
    else {
      if (this.textareaContentHyperlink.length <= 0 && this.chkTypeValue === 'Link') {
        this.errorMessage = "*Hyperlink is required"
        this.spinnerService.hide("bmwSpinner");
        return;
      }
      formData.append('documentFileName', this.textareaContentHyperlink);
      formData.append('documentTitle', this.textareaContent);
    }
    formData.append('makeName', selectedMake.makeName);
    formData.append('releaseDate', this.inputDate);
    formData.append('attachmentType', this.chkTypeValue);
    if (this.faqOrTopLink === 'faq') {
      this.adminService.updateFAQ(formData, this.docId).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.updateBulletinModal.nativeElement.click();
          this.reactivateOrDeactivateDocument(this.reactivateOrDeactivate, 'faq', this.docId, selectedMake.makeName);
          this.toastService.popToast('Document updated');
          this.clearContent();
          this.faqTopLinkDoc = null;
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    } else if (this.faqOrTopLink === 'topLink') {
      this.adminService.updateTopLink(formData, this.docId).subscribe(data => {
        if (data) {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = '';
          this.updateBulletinModal.nativeElement.click();
          this.reactivateOrDeactivateDocument(this.reactivateOrDeactivate, 'topLink', this.docId, selectedMake.makeName);
          this.toastService.popToast('Document updated');
          this.uploadedFile = null;
          this.faqTopLinkDoc = null;
        }
      },
        error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.message;
        });
    }
  }
  reactivateOrDeactivateDocument(reactivateOrDeactivate, documentType, documentNumber, makeName) {
    if (reactivateOrDeactivate === 'reactivate') {
      switch (documentType) {
        case 'td':
          this.adminService.reactivateTechDoc(documentNumber, this.userEmail, makeName)
            .subscribe(data => this.reactivateOrDeactivate = null);
          break;
        case 'of':
          this.adminService.reactivateOperatingFluids(documentNumber, this.userEmail, makeName)
            .subscribe(data => this.reactivateOrDeactivate = null);
          break;
        case 'tm':

          this.adminService.reactivateTechTrainingManual(documentNumber, this.userEmail, makeName).subscribe(data => this.reactivateOrDeactivate = null);
          break;
        case 'bpm':

          this.adminService.reactivateBodyAndPaintManual(documentNumber, this.userEmail, makeName).subscribe(data => this.reactivateOrDeactivate = null);
          break;
        case 'eq':
          this.adminService.reactivateEquipmentManual(documentNumber, this.userEmail, makeName)
            .subscribe(data => this.reactivateOrDeactivate = null);
          break;
        case 'faq':
          this.adminService.reactivateFAQ(documentNumber, this.userEmail, makeName).subscribe(data => {
            this.spinnerService.hide("bmwSpinner");
            this.reactivateOrDeactivate = null;
            this.toastService.popToast('Reactivated FAQ');
          }, error => {
            this.spinnerService.hide("bmwSpinner");
            this.toastService.popToast('Update failed');
          });
          break;
        case 'topLink':
          this.adminService.reactivateTopLink(documentNumber, this.userEmail, makeName)
            .subscribe(data => {
              this.spinnerService.hide("bmwSpinner");
              this.reactivateOrDeactivate = null;
              this.toastService.popToast('Reactivated TopLink');
              this.clearContent();
            }, error => {
              this.spinnerService.hide("bmwSpinner");
              this.toastService.popToast('Update failed');
            });
          break;
        case 'bulletin':
        case 'pbs':
          this.adminService.reactivateBulletin(documentNumber, this.userEmail, makeName)
            .subscribe(data => this.reactivateOrDeactivate = null);
          break;
      }
    } else if (reactivateOrDeactivate === 'deactivate') {
      switch (documentType) {
        case 'td':
          this.adminService.deactivateTechDoc(documentNumber, this.userEmail, makeName)
            .subscribe(data => this.reactivateOrDeactivate = null);
          break;
        case 'of':
          this.adminService.deactivateOperatingFluids(documentNumber, this.userEmail, makeName)
            .subscribe(data => this.reactivateOrDeactivate = null);
          break;
        case 'tm':

          this.adminService.deactivateTechTrainingManual(documentNumber, this.userEmail, makeName).subscribe(data => this.reactivateOrDeactivate = null);
          break;
        case 'bpm':

          this.adminService.deactivateBodyAndPaintManual(documentNumber, this.userEmail, makeName).subscribe(data => this.reactivateOrDeactivate = null);
          break;
        case 'eq':
          this.adminService.deactivateEquipmentManual(documentNumber, this.userEmail, makeName)
            .subscribe(data => this.reactivateOrDeactivate = null);
          break;
        case 'faq':
          this.adminService.deactivateFAQ(documentNumber, this.userEmail, makeName).subscribe(data => {
            this.reactivateOrDeactivate = null;
            this.spinnerService.hide("bmwSpinner");
            this.toastService.popToast('Deactivated FAQ');
          }, error => {
            this.spinnerService.hide("bmwSpinner");
            this.toastService.popToast('Update failed');
          });

          break;
        case 'topLink':
          this.adminService.deactivateTopLink(documentNumber, this.userEmail, makeName)
            .subscribe(data => {
              this.reactivateOrDeactivate = null;
              this.spinnerService.hide("bmwSpinner");
              this.toastService.popToast('Deactivated TopLink');
            }, error => {
              this.spinnerService.hide("bmwSpinner");
              this.toastService.popToast('Update failed');
            });
          break;
        case 'bulletin':
        case 'pbs':
          this.adminService.deactivateBulletin(documentNumber, this.userEmail, makeName)
            .subscribe(data => this.reactivateOrDeactivate = null);
          break;
      }
    }
  }

  setDefaultDate(): string {
    let d = new Date();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  handleTypeValue() {
    // Reset file and hyperlink inputs when type changes
  }

  handleBrandChange() {

    let make: string;

    if (typeof this.inputMake === 'object') {
      make = this.inputMake['makeName'];
    } else {
      make = this.inputMake;
    }

    if (make === 'BMW' || make === 'MINI') {
      this.showTakata = true;
      this.mainGroupList = APP_SETTINGS.mainGroupList;
    } else if (make === 'MOTORRAD') {
      this.showTakata = false;
      this.mainGroupList = APP_SETTINGS.motorradMainGroupList;
    } else if (make === 'ROLLSROYCE') {
      this.showTakata = false;
      this.mainGroupList = APP_SETTINGS.mainGroupList;
    }

    this.filterCategories(make);
  }

  handleBrandChangeAdd() {

    let make: string;

    if (typeof this.inputMake === 'object') {
      make = this.inputMake['makeName'];
    } else {
      make = this.inputMake;
    }

    if (make === 'BMW' || make === 'MINI') {
      this.showTakata = true;
      this.mainGroupList = APP_SETTINGS.mainGroupList;
    } else if (make === 'MOTORRAD') {
      this.showTakata = false;
      this.mainGroupList = APP_SETTINGS.motorradMainGroupList;
    } else if (make === 'ROLLSROYCE') {
      this.showTakata = false;
      this.mainGroupList = APP_SETTINGS.mainGroupList;
    }

    this.inputDate = this.setDefaultDate();
    this.filterCategoriesActive(make);

  }


  handleMcbInfoChange(event) {
    if (event.target.value === 'mccurrent') {
      this.showDefaultBn = true;
    } else if (event.target.value === 'mclegacy') {
      this.showDefaultBn = false;
    }
  }

}